import getAsyncStatusKeyPath from 'shared/utils/getAsyncStatusKeyPath';

export const baseKeyPath = ['brandInfo'];

/**
 * Generate the BrandInfo Keypath
 * If requestKey is unspecified, the returned keyPath refers to all requests for the specified asyncId
 * @param {string} asyncId UUID used to group requests issued by a particular feature
 * @param {string?} requestKey identifier used to classify the type of request
 * @param {string?} instanceId identifier used to store an intance of a request (for simultaneous requests of the same type)
 * @returns {Array} Array of strings [...baseKeyPath, asyncId {, requestKey {, instanceId}}]
 */
const keyPath = (asyncId, requestKey = null, instanceId = null) =>
	getAsyncStatusKeyPath(asyncId, baseKeyPath, requestKey, instanceId);

export default keyPath;
